import axios from 'axios';

export const WEBBACK_URL = process.env.REACT_APP_WEBBACK_URL || 'http://localhost:8080';

export const createWebBackApi = (config = {}) => {
  const instance = axios.create({
    baseURL: WEBBACK_URL,
    ...config,
  });

  instance.interceptors.request.use(
    (requestConfig) => {
      const token = localStorage.getItem('authLisualToken');
      if (token) {
        requestConfig.headers.Authorization = `Bearer ${token}`;
      }
      return requestConfig;
    },
    (error) => Promise.reject(error)
  );

  // Sólo local: la vista previa (/__preview-inicio) simula el motor de video en todas las instancias.
  if (process.env.NODE_ENV === 'development') (createWebBackApi.instancias = createWebBackApi.instancias || []).push(instance);

  return instance;
};

const webBackApi = createWebBackApi();

export default webBackApi;
